import React from 'react';
import TimeKeeper from 'react-timekeeper';
import { timeToDisplayFormat, timeToSystemFormat } from '../../helpers/timeHelper';

interface TimeSelectProps {
  value: string;
  onChange: (value: string) => void;
  isInvalid?: boolean;
}

interface TimeSelectState {
  time: string;
  isPickerOpen: boolean;
  isInvalid: boolean;
}

const acceptedTimeFormat = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

class TimeSelect extends React.PureComponent<TimeSelectProps, TimeSelectState> {
  readonly state = {
    time: timeToDisplayFormat(this.props.value),
    isPickerOpen: false,
    isInvalid: this.props.isInvalid || false
  };

  componentDidUpdate(prevProps: TimeSelectProps) {
    if (this.props.value !== prevProps.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ time: timeToDisplayFormat(this.props.value) });
    }
  }

  onChange = (value: any) => {
    if (value.target.value.match(acceptedTimeFormat)) this.setState({ time: value.target.value, isInvalid: false });
    else this.setState({ time: value.target.value, isInvalid: true });
  };

  onBlur = () => {
    if (!this.state.isPickerOpen) {
      this.setState({ isPickerOpen: false });

      if (this.state.time.match(acceptedTimeFormat)) {
        this.props.onChange(timeToSystemFormat(this.state.time));
      } else this.setState({ isInvalid: true });
    }
  };

  onTimeChange = (value: any) => {
    this.setState({ time: value.formatted24, isInvalid: false });
  };

  onDoneClick = async () => {
    await this.setState({ isPickerOpen: false });
    this.onBlur();
  };

  render() {
    return (
      <div>
        <input
          maxLength={5}
          value={this.state.time}
          type="text"
          className={`modal-time-input form-input form-control${this.state.isInvalid ? ' is-invalid' : ''}`}
          onClick={() => this.setState({ isPickerOpen: true })}
          onBlur={() => this.onBlur()}
          onChange={(value) => this.onChange(value)}
        />
        {this.state.isPickerOpen && (
          <div className="position-absolute to-very-front">
             <TimeKeeper
              switchToMinuteOnHourSelect
              hour24Mode
              closeOnMinuteSelect={false}
              onDoneClick={this.onDoneClick}
              time={this.state.time.match(acceptedTimeFormat) ? this.state.time : '00:00'}
              onChange={(value: any) => this.onTimeChange(value)}
             />
          </div>
        )}
      </div>
    );
  }
}

export default TimeSelect;
